import React, { useEffect } from 'react'
import "../../CSS/Contabilidad.css"
import { useNavigate } from "react-router";
import {getPermission} from "../../Conexiones/Conexion"

function Contabilidad() {
  const navigate = useNavigate();
  useEffect(()=>{
    const getContabilidad = async () =>{
        const usuario = JSON.parse(sessionStorage.getItem('user')) 
        const idUsuario = usuario[0].idUsuario
        const permiso = await getPermission(idUsuario,21);
        if(!permiso){
            navigate('/inicio')
        }
    }
    getContabilidad()
},[navigate])
  return (
    <div className='contabilidad-container'>
      <div className='contabilidad-header'>
        <h1>CONTABILIDAD</h1>
      </div>
      <div className='contabilidad-body'>
        <div className='main-box'>
          <div className='box' onClick={()=>navigate('/inicio/Contabilidad/Proyectos')}>
            <div className='inner in2' title='PROYECTOS'>
              <h3>PROYECTOS</h3>
            </div>
          </div>
          {/*<div className='box'>
            <div className='inner' title='CONSTRUCCIÓN'>
              <h3>CONSTRUCCIÓN</h3>
            </div>
          </div>*/}
          {/*<div className='box'>
            <div className='inner' title='DESARROLLO INMOBILIARIO'>
              <h3>DESARROLLO INMOBILIARIO</h3>
            </div>
          </div>*/}
          <div className='box' onClick={()=>navigate('/inicio/Contabilidad/Inmobiliaria')}>
            <div className='inner' title='INMOBILIARIA'>
              <h3>INMOBILIARIA</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contabilidad